import { getPermissionState, marcarPerdaDeNotificacao } from './permission';
import { isSoundEnabled, isAudioBlocked } from './audio';

// Evento interno consumido por useAbrirChatDaNotificacao para navegar sem reload.
export const EVENTO_ABRIR_CHAT = 'lais:abrir-chat';

const ICONE_PADRAO = '/favicon/android-chrome-192x192.png';
const BADGE_PADRAO = '/favicon/favicon-32x32.png';

// Guarda as notificacoes vivas por tag para poder substituir em vez de empilhar.
const abertas = new Map();

/**
 * Cria uma notificacao de desktop.
 *
 * Diferencas em relacao ao `new Notification` solto que existia antes:
 * - `tag` + `renotify`: uma segunda mensagem do mesmo chat substitui a anterior
 *   em vez de empilhar 20 balões na tela;
 * - `onclick`: foca a janela e abre a conversa (antes o clique nao fazia nada);
 * - nunca pede permissao aqui — pedir fora de um gesto do usuario e recusado
 *   por Firefox/Safari e ainda descarta a notificacao atual.
 */
export function notify({
  title,
  body,
  icon,
  tag,
  chatId,
  url,
  requireInteraction = false,
  ttl = 10000,
} = {}) {
  if (getPermissionState() !== 'granted') {
    marcarPerdaDeNotificacao();
    return null;
  }

  try {
    const anterior = tag && abertas.get(tag);
    if (anterior) {
      try {
        anterior.close();
      } catch {
        // Notificacao ja fechada pelo usuario/SO.
      }
    }

    const notificacao = new Notification(title || 'LAIS', {
      body: String(body || '').slice(0, 200),
      icon: icon || ICONE_PADRAO,
      badge: BADGE_PADRAO,
      ...(tag ? { tag, renotify: true } : {}),
      requireInteraction,
      // Se o nosso audio esta funcionando, silencia o chime do SO para nao tocar
      // dois sons. Se o autoplay esta bloqueado ou o som esta mudo, deixa o SO
      // fazer barulho — melhor um som duplicado do que nenhum aviso.
      silent: isSoundEnabled() && !isAudioBlocked(),
    });

    if (tag) abertas.set(tag, notificacao);

    notificacao.onclick = (evento) => {
      evento.preventDefault();
      try {
        window.focus();
      } catch {
        // Navegador pode recusar o focus; a navegacao abaixo ainda vale.
      }
      if (chatId) {
        window.dispatchEvent(new CustomEvent(EVENTO_ABRIR_CHAT, { detail: { chatId } }));
      } else if (url) {
        window.location.assign(url);
      }
      try {
        notificacao.close();
      } catch {
        // Idem.
      }
    };

    notificacao.onclose = () => {
      if (tag && abertas.get(tag) === notificacao) abertas.delete(tag);
    };

    notificacao.onerror = (err) => console.debug('[notificacoes] erro na notificacao', err);

    if (ttl > 0) {
      setTimeout(() => {
        try {
          notificacao.close();
        } catch {
          // Idem.
        }
      }, ttl);
    }

    return notificacao;
  } catch (err) {
    console.warn('[notificacoes] falha ao criar Notification', err);
    return null;
  }
}

export function closeByTag(tag) {
  const notificacao = abertas.get(tag);
  if (!notificacao) return;
  try {
    notificacao.close();
  } catch {
    // Idem.
  }
  abertas.delete(tag);
}
